<style scoped lang="scss">
li {
  list-style: none;
}

.nav_box {
  // position: fixed;
  left: 0;
  height: 100%;
  background: #fff;
  width: 210px;

  ul {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  li.title {
    background: #f9f9f9;
    color: #999999;
    padding-left: 50px;
  }

  li {
    box-sizing: border-box;
    padding-left: 60px;
    height: 50px;
    line-height: 50px;
    text-align: left;
    color: #666666;
    cursor: pointer;
  }

  li.c:hover {
    background: #f0f6ff;
  }

  li.li_active {
    background: #f0f6ff;
    border-right: 3px solid #3399ff;
    color: #409eff;
  }
}
</style>
<template>
  <div class="nav_box">
    <ul>
      <li
          v-for="(item, index) in nav"
          :key="index"
          :class="item.type == 'title'?'title' : item.active ? 'c li_active' : 'c'"
          @click="handleClick(item)"
      >
        {{ item.chName }}
      </li>
    </ul>
  </div>
</template>

<script>
import request from '@/utils/apiRequest'

export default {
  data() {
    return {
      title: "安消一体",
      nav: [
        // {
        //   name: "安保统计",
        //   active: true,
        //   path: "/securityManage/securityStatistics",
        // },
        // {
        //   name: "事件记录",
        //   active: false,
        //   path: "/securityManage/eventRecord",
        // },
        // {
        //   name: "巡更管理",
        //   active: false,
        //   path: "/securityManage/patrolManage",
        // },
        // {
        //   name: "事件上报",
        //   active: false,
        //   path: "/securityManage/eventReport",
        // },
        // {
        //   name: "消防可视化",
        //   active: true,
        //   path: "/securityManage/securityView",
        // },
      ],
    };
  },
  methods: {
    handleClick(item) {
      let tempIndex = this.nav.indexOf(item);
      this.nav = this.nav.map((item) => {
        item.active = false;
        return item;
      });
      this.nav[tempIndex].active = true;
      this.$router.push(item.url);
    },
    getMenu(callback) {
      request({
        url: '/user/sysGroup/getCanFunction'
      }).then(res => {
        if (res.data.data[0].children != null) {
          if (
              res.data.data[0].children[0].url != null &&
              res.data.data[0].children[0].url != ""
          ) {
            this.$router.replace(
                res.data.data[0].children[0].url
            );
          } else {
            this.$router.replace(
                res.data.data[0].children[1].url
            );
          }
        } else {
          // this.$router.replace(res.data.data[0].url);
        }
        callback(res.data)
      })
    }
  },
  mounted() {
    // this.getMe
    // let menus = this.$store.state.user.menus.data;
    let menus = JSON.parse(localStorage.getItem('USER_MENU_LIST'))
    let menu = menus.filter((item) => {
      if (item.enName == "axyt") return item;
    })[0];
    this.nav = menu.children;
    let tempPath = this.$route.path;
    let tempObj = this.nav.filter((item) => {
      if (item.url == tempPath) return item;
    })[0];
    let tempIndex = this.nav.indexOf(tempObj);
    this.nav = this.nav.map((item) => {
      item.active = false;
      return item;
    });
    this.nav[tempIndex].active = true;
  }
};
</script>

